// Display names + catalog for MetaMask/DEXEVM chain selection - shared between the add-wallet
// flow (TabView.js) and the manage-chains dialog (Wallet.js) so both stay in sync with the same
// vocabulary dex-service's ApiRefData.source / com.blockstats.enums.Source values use.
export const CHAIN_DISPLAY_NAMES = {
  ETHEREUM: 'Ethereum', ARBITRUM: 'Arbitrum', ARBITRUMNOVA: 'Arbitrum Nova',
  AVALANCHE: 'Avalanche', BASE: 'Base', BINANCECHAIN: 'BNB Chain', BLAST: 'Blast',
  CELO: 'Celo', DEGEN: 'Degen', FANTOM: 'Fantom', GNOSIS: 'Gnosis', LINEA: 'Linea',
  MANTAPACIFIC: 'Manta Pacific', MANTLE: 'Mantle', MODE: 'Mode', OPTIMISIM: 'Optimism',
  POLYGON: 'Polygon', POLYGONZKEVM: 'Polygon zkEVM', SCROLL: 'Scroll', SONIC: 'Sonic',
  ZKSYNC: 'zkSync', ZORA: 'Zora', XLAYER: 'X Layer', ZIRCUIT: 'Zircuit', SEI: 'Sei',
  VANA: 'Vana', UNICHAIN: 'Unichain', ABSTRACT: 'Abstract', HYPEREVM: 'HyperEVM',
  BERACHAIN: 'Berachain', AURORA: 'Aurora', REDSTONE: 'Redstone', VICTION: 'Viction',
};

export const SUPPORTED_EVM_CHAINS = Object.keys(CHAIN_DISPLAY_NAMES);

export const WALLET_ADDRESS_PATTERN = /^0x[a-fA-F0-9]{40}$/;

export const chainLabel = (chain) => CHAIN_DISPLAY_NAMES[chain] || chain;

// Same GCS bucket + per-chain-name convention already used for the individually-added legacy
// chain wallets' own imgUrl (see wallets-configuration), reused here so a chain's icon looks
// identical whether it's shown as its own legacy wallet card or as a row inside a MetaMask
// wallet's chain list. A handful of chains (ArbitrumNova, Aurora, PolygonZkEvm, Redstone,
// Viction) have no asset in that bucket yet - chainIcon() returns null for those and callers
// fall back to a plain initial-letter badge instead of a broken image.
const GCS_LOGO_BASE = 'https://storage.googleapis.com/dev-prj-frontend-apps/exchange-logos';
export const CHAIN_ICON_URLS = {
  ETHEREUM: `${GCS_LOGO_BASE}/ETHEREUM.png`, ARBITRUM: `${GCS_LOGO_BASE}/ARBITRUM.png`,
  AVALANCHE: `${GCS_LOGO_BASE}/AVALANCHE.png`, BASE: `${GCS_LOGO_BASE}/BASE.png`,
  BINANCECHAIN: `${GCS_LOGO_BASE}/BINANCECHAIN.png`, BLAST: `${GCS_LOGO_BASE}/BLAST.jpeg`,
  CELO: `${GCS_LOGO_BASE}/CELO.jpeg`, DEGEN: `${GCS_LOGO_BASE}/DEGEN.jpeg`,
  FANTOM: `${GCS_LOGO_BASE}/FANTOM.png`, GNOSIS: `${GCS_LOGO_BASE}/GNOSIS.png`,
  LINEA: `${GCS_LOGO_BASE}/LINEA.jpeg`, MANTAPACIFIC: `${GCS_LOGO_BASE}/MANTAPACIFIC.png`,
  MANTLE: `${GCS_LOGO_BASE}/MANTLE.jpeg`, MODE: `${GCS_LOGO_BASE}/MODE.jpeg`,
  OPTIMISIM: `${GCS_LOGO_BASE}/OPTIMISM.png`, POLYGON: `${GCS_LOGO_BASE}/POLYGON.png`,
  SCROLL: `${GCS_LOGO_BASE}/SCROLL.jpeg`, SONIC: `${GCS_LOGO_BASE}/SONIC.png`,
  ZKSYNC: `${GCS_LOGO_BASE}/ZKSYNC.jpeg`, ZORA: `${GCS_LOGO_BASE}/ZORA.jpeg`,
  XLAYER: `${GCS_LOGO_BASE}/XLAYER.jpeg`, ZIRCUIT: `${GCS_LOGO_BASE}/ZIRCUIT.png`,
  SEI: `${GCS_LOGO_BASE}/SEI.png`, VANA: `${GCS_LOGO_BASE}/VANA.jpg`,
  UNICHAIN: `${GCS_LOGO_BASE}/UNICHAIN.png`, ABSTRACT: `${GCS_LOGO_BASE}/ABSTRACT.png`,
  HYPEREVM: `${GCS_LOGO_BASE}/HYPEREVM.png`, BERACHAIN: `${GCS_LOGO_BASE}/BERACHAIN.jpeg`,
};

export const chainIcon = (chain) => CHAIN_ICON_URLS[chain] || null;
